<template>
<div class="mb-5">
    <b-card header-tag="header">
      <template #header>
          <div class="d-flex flex-row align-items-center p-2">
              <Icon style="color: green; font-size: 25px;" icon="check-circle"/>
              <h3 class="confirmation_step-header m-0 ml-3">{{stepTitle}}</h3>
          </div>
          <StepLink class="m-0 p-2" :step="WizardStep" >Edit</StepLink>
      </template>
      <slot/>
    </b-card>
</div>
</template>

<script>
import Icon from '../../components/Icon.vue'
import StepLink from './StepLink'
export default {
  name: 'ConfirmationContent',
  props: [ 'stepTitle', 'WizardStep' ],
  components: { Icon, StepLink }
}
</script>

<style scoped>
header {
    background: #f0f0f5;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.confirmation_step-header {
    color: #637080;
    font-size: 1.5rem;
    font-weight: bold;
}
/* bootstrap class */
.card-body {
    padding: 0;
}
</style>
